<template>
  <div class="content">
    <div class="center">
      <div class="detail-box">
        <div class="device-box flex-row">
          <div class="device-img"><img :src="$imgUrl + ele_info.avatar" /></div>
          <div class="device-info">
            <p class="name">{{ ele_info.name }}</p>
            <div class="info">
              <div class="price-box flex-row">
                <span>价格</span>
                <span class="price">￥{{ ele_info.price }}/天</span>
              </div>
              <p class="tips">
                *价格说明
                <br />
                以上价格标注为参考价，具体价格您根据需求下单后待双方协商
              </p>
            </div>
            <div class="type">
              <span>电工类型</span>
              {{ ele_info.type }}
            </div>
          </div>
        </div>
      </div>

      <div class="order">
        <div class="order-info">
          <div class="top flex-row">
            <div class="item address-box">
              <p class="tit1">地址信息</p>
              <div class="address flex-row">
                <!-- <div class="address-info">
									<p>河北石家庄长安区</p>
									<p>详细地址介绍详细地址介绍</p>
								</div>
								<button>选择地址</button> -->
                <el-select
                  v-model="addressVal"
                  placeholder="请选择地址"
                  size="medium"
                >
                  <el-option
                    v-for="(item, index) in addressList"
                    :key="item.id"
                    :label="
                      item.provinceName +
                      '-' +
                      item.cityName +
                      '-' +
                      item.countyName +
                      ' ' +
                      item.address
                    "
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="item service-item">
              <p class="tit2">用工时长</p>
              <div class="cont flex-row">
                <div class="input-box">
                  <el-input
                    v-model="days"
                    type="number"
                    placeholder="请输入用工时长"
                    size="medium"
                  >
                    <template slot="prepend"> 时长： </template>
                    <template slot="append"> /天 </template>
                  </el-input>
                </div>
              </div>
            </div>
            <div class="item date-item">
              <div class="cont flex-row">
                <p>开始时间：</p>
                <el-date-picker
                  class="date"
                  v-model="date"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </div>
              <p class="tips">*结束时间为次日开始时间的日期</p>
            </div>
          </div>
          <div class="flex-row">
            <div class="work-cont">
              <p class="tit3">工作内容：</p>
              <div class="textarea">
                <textarea
                  v-model="introduce"
                  placeholder="告诉电工他需要做什么准备"
                ></textarea>
              </div>
            </div>
            <div class="bot flex-row">
              <button class="apply" @click="submitApply(1)">提交申请</button>
              <!-- <button class="saveOrder" @click="submitApply(0)">
                保存订单
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RelatedCompany from "@/components/ordinary/relatedCompany.vue";
import api from "../../http/electrician/api.js";
import {
  getEleInfo,
  lanuch_application,
  adderssList,
} from "../../http/api/ordinary.js";
export default {
  components: {
    RelatedCompany,
  },
  data() {
    return {
      num: 1,
      moreShow: false,
      activeNum: 0,
      // date: new Date(),
      date: this.formatTime(),
      ele_info: {
        name: "",
        price: "",
        type: "",
        avatar: "",
      },
      ele_id: "",
      addressList: [],
      addressVal: "",
      days: "",
      introduce: "",
    };
  },
  created() {
    this.ele_id = this.$route.query.id;
    this.getEleInfo();
    this.getAddress();
  },
  methods: {
    getEleInfo() {
      getEleInfo({
        id: this.ele_id,
      }).then((res) => {
        this.ele_info = {
          name: res.name,
          price: res.price,
          type: res.typeName,
          avatar: res.heading,
        };
      });
    },
    getAddress() {
      adderssList({}).then((res) => {
        this.addressList = res.rows;
      });
    },
    submitApply(flag) {
      //   api.electrician_userinfo({}).then((res) => {
      //     console.log(res);
      //   });
      // 	console.log(this.ele_info);
      //   return;
      lanuch_application({
        time: this.days,
        startTime: this.date,
        customerAdderssId: this.addressVal,
        tasks: this.introduce,
        status: flag,
        onelecticianId: this.ele_id,
        electicianId: this.ele_id,
        price: this.ele_info.price * this.days,
        typeName: this.ele_info.type,
      }).then((res) => {
        let msg = "";
        if (flag == 1) {
          msg = "新增成功";
        } else {
          msg = "保存成功";
        }
        this.$message({
          message: msg,
          type: "success",
        });
        this.$router.push({
          path: "/personalCenter/orderShare",
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
.input-box {
  padding: @vue-spacing-col-base 0px;
  display: flex;
  align-items: center;
}

.content {
  font-size: 0.14rem;
  background: #f5f5f5;

  .center {
    width: 16.88rem;
    margin: 0 auto;
    padding: 0.2rem 0;

    button {
      outline: none;
      cursor: pointer;
    }
  }

  .detail-box {
    background: #ffffff;
    border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
    padding: 0.28rem 0.3rem 0.33rem;

    .device-box {
      .device-img {
        width: 2.96rem;
        height: 2.96rem;
        border-radius: 0.06rem;
        margin-right: 0.2rem;

        img {
          width: 100%;
          height: 100%;
          border-radius: 0.06rem;
        }
      }

      .device-info {
        width: 6.41rem;

        .name {
          font-size: 0.2rem;
          color: #333333;
          line-height: 0.23rem;
          font-weight: 500;
        }

        .price-box {
          font-size: 0.14rem;
          color: #000000;
          line-height: 0.2rem;
          align-items: center;
          position: relative;

          .price {
            color: #ff4141;
            margin-left: 0.1rem;
          }
        }

        .tips {
          font-size: 0.13rem;
          color: #8f8f8f;
          line-height: 0.33rem;
          margin-top: 0.1rem;
        }

        .info {
          width: calc(100% - 0.26rem);
          background: #fff9f5;
          border-radius: 0.06rem;
          margin-top: 0.16rem;
          padding: 0.13rem;
        }

        .type {
          background: #f8f8f8;
          border-radius: 0.06rem;
          padding: 0.13rem 0.1rem;
          font-size: 0.14rem;
          color: #333333;
          margin-top: 0.1rem;

          span {
            color: #aaaaaa;
            margin-right: 0.2rem;
          }
        }
      }
    }
  }

  .order {
    margin-top: 0.1rem;
    background: #ffffff;
    border-radius: 0.06rem;
    padding: 0.3rem 0;

    .order-info {
      padding: 0 0.3rem;

      .top {
        .address-box {
          margin-right: 1.7rem;

          .tit1 {
            font-size: 0.16rem;
            color: #000000;
            line-height: 0.2rem;
          }

          .address {
            width: 3.33rem;
            margin-top: 0.12rem;
            background: #f5f5f5;
            border-radius: 0.06rem;
            padding: 0.15rem;
            position: relative;

            .address-info {
              flex: 1;
              padding-right: 1.1rem;

              p {
                font-size: 0.14rem;
                color: #333333;
                line-height: 1.2;
              }

              p:nth-of-type(2) {
                margin-top: 0.1rem;
                font-size: 0.14rem;
                color: #5f5f5f;
                line-height: 1.2;
              }
            }

            button {
              width: 0.93rem;
              height: 0.3rem;
              background: #ff5400;
              border-radius: 0.03rem;
              font-size: 0.12rem;
              color: #ffffff;
              line-height: 0.3rem;
              border: none;
              position: absolute;
              right: 0.17rem;
              bottom: 0.18rem;
            }
          }
        }

        .service-item {
          margin-right: 0.69rem;

          .tit2 {
            font-size: 0.16rem;
            color: #000000;
            line-height: 0.2rem;
          }

          .cont {
            margin-top: 0.12rem;
            width: 3.33rem;
            background: #f5f5f5;
            border-radius: 0.06rem;
            justify-content: space-between;
            padding: 0 0.14rem;

            span {
              font-size: 0.14rem;
              line-height: 0.43rem;
            }
          }
        }

        .date-item {
          .cont {
            margin-top: 0.32rem;
            width: 3.33rem;
            height: 0.43rem;
            background: #f5f5f5;
            border-radius: 0.06rem;
            justify-content: space-between;
            padding: 0 0.14rem;
            align-items: center;

            p {
              white-space: nowrap;
              line-height: 0.43rem;
            }

            .date {
              border-radius: 0.06rem;

              /deep/.el-input {
                flex: 1;
              }

              /deep/.el-input__inner {
                width: 100%;
                height: 0.43rem;
                background: #f5f5f5;
                padding-left: 0;
                font-size: 0.14rem;
                color: #000000;
                border: none;
                text-align: center;
              }

              /deep/.el-input__prefix {
                left: unset;
                right: 0;
              }

              /deep/.el-input__icon {
                line-height: 0.43rem;
              }
            }
          }
        }
      }

      .work-cont {
        margin-top: 0.55rem;

        .tit3 {
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;
        }

        .textarea {
          width: 6rem;
          height: 1.25rem;
          background: #f5f5f5;
          border-radius: 0.06rem;
          padding: 0.1rem 0.15rem;
          margin-top: 0.12rem;

          textarea {
            width: 100%;
            height: 100%;
            font-size: 0.14rem;
            background: #f5f5f5;
            outline: none;
            border: none;
            resize: none;
          }

          textarea::placeholder {
            color: #bababa;
          }
        }
      }

      .tips {
        font-size: 0.13rem;
        color: #ff7575;
        margin-top: 0.1rem;
        line-height: 0.2rem;
      }
    }

    .bot {
      margin-top: 0.4rem;
      width: calc(100% - 0.6rem);
      padding: 0.22rem 0.3rem 0;
      justify-content: flex-end;
      align-items: flex-end;

      .apply {
        width: 1.38rem;
        height: 0.4rem;
        background: #686868;
        border: 1px solid #686868;
        border-radius: 0.09rem;
        font-size: 0.14rem;
        color: #ffffff;
        line-height: 0.4rem;
        text-align: center;
        margin-left: 0.35rem;
      }

      .saveOrder {
        width: 1.38rem;
        height: 0.4rem;
        background: #ffffff;
        border: 1px solid #686868;
        border-radius: 0.09rem;
        font-size: 0.14rem;
        color: #686868;
        line-height: 0.4rem;
        text-align: center;
        margin-left: 0.32rem;
      }
    }
  }
}
</style>
